import { render } from "./Widget5.vue?vue&type=template&id=ad5e9cba&scoped=true"
import script from "./Widget5.vue?vue&type=script&lang=js"
export * from "./Widget5.vue?vue&type=script&lang=js"

import "./Widget5.vue?vue&type=style&index=0&id=ad5e9cba&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5e9cba"]])

export default __exports__